import Vue from 'vue'

export const componentRegister = () => {
  Vue.component('company-footer', () => import('@/components/company-footer.vue'))
  Vue.component('card-hover', () => import('@/components/card-hover.vue'))
  Vue.component('connect-wallet', () => import('@/components/connect-wallet.vue'))
  Vue.component('connect-metamask', () => import('@/components/wallet/connect-metamask.vue'))
  Vue.component('address-copy-board', () => import('@/components/address-copy-board.vue'))
  Vue.component('page-footer', () => import('@/components/page-footer.vue'))
}
